(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('PolicyRulesController', ["$scope", "routeHelper", "modulesManager", function ($scope, routeHelper, modulesManager) {
        $scope.addHref = routeHelper.getHref('policy-rule-add');
        var saasListOrder = {
            office365_emails: 1,
            office365_onedrive: 2,
            ms_teams: 3,
            office365_sharepoint: 4
        };
        modulesManager.init(true).then(function () {
            $scope.saasList = _(angular.copy(modulesManager.activeSaasApps())).chain().map(function (saas) {
                saas.api = {};
                return saas;
            }).sortBy(function (saas) {
                return saasListOrder[saas.name] || 10;
            }).value();
        });
        if (routeHelper.getParams().saasActive) {
            $scope.saasActive = routeHelper.getParams().saasActive;
        }
    }]);
}());